import { useAppSelector } from '@/app/store/store';
import {
  isCoinOrBarPageByTags,
  isCoinOrBarPageByUrl,
  // isGoldCoinPlpPage,
} from '../../utils/multivariateExperimentUtils';

export function useMultivariateExperiment() {
  const experimentState = useAppSelector((s) => s.multivariateExperiment);

  return {
    homePageVariant: experimentState?.home ?? 'NONE',
    // goldCoinPlpVariant: experimentState?.goldCoinPlp ?? 'NONE',
    plpVariant: experimentState?.plp ?? 'NONE',
    pdpVariant: experimentState?.pdp ?? 'NONE',
    guestCheckoutVariant: experimentState?.guestCheckout ?? 'NONE',
    rawCookies: experimentState?.rawCookies ?? {},
    isCoinOrBarPageByTags,
    isCoinOrBarPageByUrl,
    // isGoldCoinPlpPage,
  };
}
